import type { ReadonlyDeep } from 'type-fest';

import { ContactInfoInput } from '@e-socna/data-layer';

import { pruneInput } from '../../../utils/prune-input.util';

export function contactInfoForm2ApiMapper(
  contactInfo: ReadonlyDeep<ContactInfoInput>,
): ReadonlyDeep<ContactInfoInput> {
  const {
    email,
    faxNumber,
    landlineNumber,
    mobileNumber,
    professionalNumber,
    website,
    ...contactInfoInput
  } = pruneInput(contactInfo, ContactInfoInput);

  return {
    ...contactInfoInput,
    // eslint-disable-next-line @typescript-eslint/prefer-nullish-coalescing
    email: email || null,
    // eslint-disable-next-line @typescript-eslint/prefer-nullish-coalescing
    faxNumber: faxNumber || null,
    // eslint-disable-next-line @typescript-eslint/prefer-nullish-coalescing
    landlineNumber: landlineNumber || null,
    // eslint-disable-next-line @typescript-eslint/prefer-nullish-coalescing
    mobileNumber: mobileNumber || null,
    // eslint-disable-next-line @typescript-eslint/prefer-nullish-coalescing
    professionalNumber: professionalNumber || null,
    // eslint-disable-next-line @typescript-eslint/prefer-nullish-coalescing
    website: website || null,
  };
}
